module.exports = __webpack_public_path__ + "static/patriciawork3-a7a5c61936e87596e340e6c5943ef650.jpg";